import React from 'react';
import {Modal} from 'antd';
import {ArrowRightOutlined, ExclamationCircleOutlined} from '@ant-design/icons';

import './duplicateRegistrationWarning.css';

const OverCapacityWarningBody = ({
  fromStatusLabel,
  toStatusLabel,
  overCapacityOptions = [],
  fallbackMessage,
}) => {
  if (fallbackMessage && !fromStatusLabel) {
    return (
      <div className='duplicate-reg-warning'>
        <p className='duplicate-reg-warning__lead'>{fallbackMessage}</p>
        <p className='duplicate-reg-warning__hint'>
          Confirm only if you intend to increase capacity.
        </p>
      </div>
    );
  }

  const optionNames = overCapacityOptions.map((option) => option.name);
  const optionLabel =
    optionNames.length === 1 ? optionNames[0] : optionNames.join(', ');

  return (
    <div className='duplicate-reg-warning'>
      <p className='duplicate-reg-warning__lead'>
        This registration is for &ldquo;{optionLabel}&rdquo;, which is already at
        maximum capacity. Proceeding will increase the option capacity by one and
        confirm this registration.
      </p>

      <div className='duplicate-reg-warning__card'>
        <div className='duplicate-reg-warning__row'>
          <span className='duplicate-reg-warning__label'>Status change</span>
          <div className='duplicate-reg-warning__status'>
            <span className='duplicate-reg-warning__tag'>{fromStatusLabel}</span>
            <ArrowRightOutlined className='duplicate-reg-warning__arrow' />
            <span className='duplicate-reg-warning__tag duplicate-reg-warning__tag--new'>
              {toStatusLabel}
            </span>
          </div>
        </div>
        {overCapacityOptions.map((option) => (
          <div className='duplicate-reg-warning__row' key={option.id}>
            <span className='duplicate-reg-warning__label'>Capacity</span>
            <span className='duplicate-reg-warning__value'>
              {option.used_qty} / {option.qty}
            </span>
          </div>
        ))}
      </div>
      {fallbackMessage ? (
        <p className='duplicate-reg-warning__lead'>{fallbackMessage}</p>
      ) : null}
    </div>
  );
};

export const showOverCapacityWarningModal = ({
  fromStatusLabel,
  toStatusLabel,
  overCapacityOptions,
  fallbackMessage,
  onConfirm,
}) => {
  return new Promise((resolve) => {
    Modal.confirm({
      className: 'duplicate-reg-warning-modal',
      width: 480,
      centered: true,
      icon: null,
      title: (
        <div className='duplicate-reg-warning-modal__header'>
          <ExclamationCircleOutlined className='duplicate-reg-warning-modal__header-icon' />
          <div className='duplicate-reg-warning-modal__header-text'>
            <div className='duplicate-reg-warning-modal__title'>
              Above maximum capacity
            </div>
            <div className='duplicate-reg-warning-modal__subtitle'>
              Confirm before proceeding
            </div>
          </div>
        </div>
      ),
      content: (
        <OverCapacityWarningBody
          fromStatusLabel={fromStatusLabel}
          toStatusLabel={toStatusLabel}
          overCapacityOptions={overCapacityOptions}
          fallbackMessage={fallbackMessage}
        />
      ),
      okText: 'Yes, proceed',
      cancelText: 'Cancel',
      onOk: async () => {
        if (!onConfirm) {
          resolve(false);
          return;
        }
        const result = await onConfirm();
        resolve(result !== false);
      },
      onCancel: () => resolve(false),
    });
  });
};
